// VHRP Connect — shared web brand tokens (mirrors mobile src/theme.ts)
export const colors = {
  surface: "#FDFBF7",
  onSurface: "#1F1A17",
  surfaceSecondary: "#FFFFFF",
  surfaceTertiary: "#F2EBE1",
  onSurfaceTertiary: "#3E352F",
  surfaceInverse: "#29211D",
  brand: "#E65100",
  brandPrimary: "#E65100",
  brandSecondary: "#D84315",
  brandDeep: "#BF360C",
  brandTertiary: "#FBE9E7",
  onBrandTertiary: "#BF360C",
  success: "#2E7D32",
  warning: "#F57F17",
  error: "#C62828",
  border: "#E8E2D9",
  borderStrong: "#C2B4A3",
  muted: "#7A6E62",
};

// Public asset URLs (copied to /public/vhrp)
export const vhrpImages = {
  logo: "/vhrp/logo.png",
  logoMark: "/vhrp/logo-mark.png",
  banner: "/vhrp/banner.jpg",
  cardBg: "/vhrp/card-bg.jpg",
  aboutHero: "/vhrp/about-hero.jpg",
  founder: "/vhrp/founder.jpg",
  teamGopal: "/vhrp/team-gopal.jpg",
  mission: "/vhrp/mission.jpg",
  values1: "/vhrp/values1.jpg",
  values2: "/vhrp/gallery3.jpg",
};

export const galleryImages = [
  "/vhrp/gallery1.jpg",
  "/vhrp/gallery2.jpg",
  "/vhrp/gallery3.jpg",
  "/vhrp/gallery4.jpg",
  "/vhrp/gallery5.jpg",
  "/vhrp/gallery6.jpg",
  "/vhrp/gallery7.jpg",
  "/vhrp/gallery8.jpg",
];

export const contactInfo = {
  landline: "0522-2637228",
  landlineHref: "tel:05222637228",
  hours: "Working hours: 11 AM – 5 PM (Mon–Sat)",
  email: "contact@vhrp.in",
  emailHref: "mailto:contact@vhrp.in",
  website: "vhrp.in",
  websiteHref: "https://vhrp.in",
  address: "2nd Floor, 2/283, Vishal Khand 2, Gomti Nagar, Lucknow, UP 226010",
  addressHref:
    "https://maps.google.com/?q=2/283+Vishal+Khand+2+Gomti+Nagar+Lucknow+226010",
};

export const COUNTRIES = [
  { name: "India", code: "+91", flag: "🇮🇳" },
  { name: "Nepal", code: "+977", flag: "🇳🇵" },
  { name: "Sri Lanka", code: "+94", flag: "🇱🇰" },
  { name: "Bangladesh", code: "+880", flag: "🇧🇩" },
  { name: "United Arab Emirates", code: "+971", flag: "🇦🇪" },
  { name: "Saudi Arabia", code: "+966", flag: "🇸🇦" },
  { name: "Qatar", code: "+974", flag: "🇶🇦" },
  { name: "Kuwait", code: "+965", flag: "🇰🇼" },
  { name: "Oman", code: "+968", flag: "🇴🇲" },
  { name: "Bahrain", code: "+973", flag: "🇧🇭" },
  { name: "Singapore", code: "+65", flag: "🇸🇬" },
  { name: "Malaysia", code: "+60", flag: "🇲🇾" },
  { name: "United States", code: "+1", flag: "🇺🇸" },
  { name: "Canada", code: "+1", flag: "🇨🇦" },
  { name: "United Kingdom", code: "+44", flag: "🇬🇧" },
  { name: "Australia", code: "+61", flag: "🇦🇺" },
  { name: "New Zealand", code: "+64", flag: "🇳🇿" },
  { name: "South Africa", code: "+27", flag: "🇿🇦" },
  { name: "Mauritius", code: "+230", flag: "🇲🇺" },
  { name: "Fiji", code: "+679", flag: "🇫🇯" },
  { name: "Germany", code: "+49", flag: "🇩🇪" },
  { name: "France", code: "+33", flag: "🇫🇷" },
  { name: "Netherlands", code: "+31", flag: "🇳🇱" },
  { name: "Japan", code: "+81", flag: "🇯🇵" },
  { name: "Thailand", code: "+66", flag: "🇹🇭" },
  { name: "Indonesia", code: "+62", flag: "🇮🇩" },
];

// Verhoeff checksum validation for Aadhaar (UIDAI spec)
const _D = [
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
  [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
  [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
  [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
  [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
  [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
  [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
  [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
  [9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
];
const _P = [
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
  [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
  [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
  [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
  [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
  [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
  [7, 0, 4, 6, 9, 1, 3, 2, 5, 8],
];

export function aadhaarValid(input) {
  const n = (input || "").replace(/\D/g, "");
  if (n.length !== 12 || n[0] === "0" || n[0] === "1") return false;
  let c = 0;
  const rev = n.split("").reverse();
  for (let i = 0; i < rev.length; i++) {
    c = _D[c][_P[i % 8][parseInt(rev[i], 10)]];
  }
  return c === 0;
}
